import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import moment from "moment";
import {getFormValues} from "redux-form";
import Charts from "../charts/Charts";
import ChartFilters from "../charts/ChartFilters";
import * as analyticsActions from "../../actions/analytics/analyticsActions";
import * as pendingPageActions from "../../actions/pendingPageActions";
import * as companyActions from "../../actions/companyActions";
import * as modalActions from "../../actions/common/modalActions";
import * as roles from "../../services/access/roles";
import MetricsContainer from "./MetricsContainer";
import statisticsSelector from "../../reducers/analytics/statisticsSelector";
import companyIdSelector from "../../reducers/analytics/companyIdSelector";
import analyticTypes from "./analyticTypes";
import * as analyticOptions from "../../components/analytics/analyticOptions";
import * as subscriptionTypes from "../company/subscriptionType";

class AnalyticsContainer extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.isAdmin = this.props.roles.indexOf(roles.FBG_WEBMASTER) !== -1;

        this.loadAnalytics = this.loadAnalytics.bind(this);
    }

    componentDidMount() {
        if (this.isAdmin) {
            this.props.actions.loadCompanies('*');  // load all companies
        }

        this.loadAnalytics(this.props.filters.graph);
    }

    loadAnalytics(filter) {
        this.props.actions.loadAnalytics({...filter, context: this.getMeta('context', 'graph')});
    }

    submit(formFields) {
//        invalidateCacheFilter();
        this.loadAnalytics(formFields);
        //@TODO [type] and [groupBy] must be cached as well
        // See the problem with [groupBy] on comment for [cacheFilterValues]
        // [type] usage will create another problem - choosing tabs won't change filter values
        //@TODO when choosing tab cache must be invalidated as well. [submit] method is not called when we click tabs.
        analyticOptions.cacheFilterValues(formFields, ['startDate', 'endDate', 'groupBy', 'type', 'companyId']);
    }

    /**
     * Get information about page from url param
     *
     * @param {string} informationType - (context, heading, ...)
     * @param {string} filterId        - (graph, metrics, ...)
     *
     * @return string
     * */
    getMeta(informationType, filterId) {
        return analyticTypes[this.props.filters[filterId].analyticType][informationType];
    }

    getEventTypes() {
        return ["pageview", "click"];
    }

    render() {
        let {
            companies,
            companyId,
            filters,
            analyticsTotal,
            statisticsIsEmpty,
            statistics
        } = this.props;

        if (!companyId) {
            return null;
        }

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">{this.getMeta("heading", 'graph')}</h1>
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <ChartFilters
                                            formValues={filters.graph}
                                            initialValues={filters.graph}
                                            companies={companies}
                                            form="chartFilters"
                                            onSubmit={this.submit.bind(this)}
                                            analyticTypes={analyticTypes}
                                            analyticType={filters.graph.analyticType}
                                            showAnalyticTypesFilter={!this.props.match.params.type}
                                            eventTypes={this.getEventTypes()}
                                        />
                                    </div>
                                </div>
                                <Charts
                                    data={statistics}
                                    statisticsIsEmpty={statisticsIsEmpty}
                                />
                                <div className="row mb-5">
                                    <div className="col-12 text-center">
                                        <b>Total for perioden: </b> {+analyticsTotal}
                                    </div>
                                </div>
                                {/*
                                    filters.metrics.analyticType !== 'total'  &&
                                        <div>
                                            <hr/>
                                            <MetricsContainer
                                                context={this.getMeta('context', 'metrics')}
                                                filterValues={filters.metrics}
                                            />
                                        </div>
                                */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let cachedData = analyticOptions.getCachedFilter();

    let filterDefaults = {
        companyId: (companyIdSelector(state) || 1),
        startDate: moment
            .utc()
            .subtract(7, "days")
            .startOf("day")
            .unix(),
        endDate: moment
            .utc()
            .endOf("day")
            .unix(),
        type: "pageview",
        groupBy: "day"
    };

    if (cachedData) {
       filterDefaults = cachedData;
    }

    // Partners MASKINSTATIONER_MINI are allowed to have access to profile statistics only.
    if (state.user.company.subscriptionType === parseInt(subscriptionTypes.MASKINSTATIONER_MINI)) {
        filterDefaults.analyticType = "profil";
    } else {
        if (ownProps.match.params.type == undefined && ownProps.match.path.indexOf('profil') !== -1) {
            filterDefaults.analyticType = "profil";
        } else {
            filterDefaults.analyticType = ownProps.match.params.type || "nyhed";
        }
    }

    const companyId = filterDefaults.companyId || 1;

    const graphFilters = {...filterDefaults, ...getFormValues("chartFilters")(state)};
    filterDefaults.groupBy = null;
    const metricsFilters = {...filterDefaults, ...getFormValues("chartFilters")(state)};

    const filters = {
        graph: graphFilters,
        metrics: metricsFilters,
    };

    return {
        user: state.user,
        roles: state.user.roles,
        companies: state.companies,
        statistics: statisticsSelector(state, filters.graph),
        statisticsIsEmpty: !state.analytics.data.length,
        filters,
        analyticsTotal: state.analytics.total,
        companyId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                analyticsActions,
                companyActions,
                modalActions,
                pendingPageActions
            ),
            dispatch
        )
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AnalyticsContainer);



// WEBPACK FOOTER //
// ./web/src/components/analytics/AnalyticsContainer.jsx